
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppCoachResourcesSupplementsListIndex} from "@/models/app/coach/resources/supplements/list/index";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppCoachResourcesSupplementsListFormCreateIndexVue from "@/views/app/coach/resources/supplements/list/form/create.vue";
import AppCoachResourcesSupplementsListFormUpdateIndexVue from "@/views/app/coach/resources/supplements/list/form/update.vue";
import AppCoachResourcesSupplementsListFormRemoveIndexVue from "@/views/app/coach/resources/supplements/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AppCoachResourcesSupplementsListFormCreateIndexVue,
    AppCoachResourcesSupplementsListFormUpdateIndexVue,
    AppCoachResourcesSupplementsListFormRemoveIndexVue,
  },
})
export default class AppCoachResourcesSupplementsListIndexVue extends Vue {
  isLoading: boolean | null = false;

  supplements: Array<AppCoachResourcesSupplementsListIndex> = [];

  async getSupplements(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/administration/supplements`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.supplements = r.data.sort(function (a, b) {
          if (a.content.name < b.content.name) {
            return -1;
          }
          if (a.content.name > b.content.name) {
            return 1;
          }
          return 0;
        });
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getSupplements();
  }
}
